import React from 'react'
import Header from '../../Components/Modules/Includes/Header'
import RaisedButton from 'material-ui/RaisedButton';
import { Route, withRouter } from 'react-router-dom';
import EditMember from './EditMember';
import * as actions from '../../Actions/index';
import { connect } from 'react-redux';
class UserAccount extends React.Component{
	constructor(props) {
	    super(props);
	    this.filterToggle = this.filterToggle.bind(this);
	    this.state = {
	    	open: false,
	    	filter: 'active-dashboard'
	    }
	    this.editMemberSave=this.editMemberSave.bind(this);
	    this.addMemberSave=this.addMemberSave.bind(this);
	    this.editMember=this.editMember.bind(this);
	    this.addTeam= this.addTeam.bind(this);
	    this.deleteMember =this.deleteMember.bind(this);
	}
	componentDidMount(){
	  	if(this.props.userdetail.currentUser){
	  		// let userId= this.props.userdetail.currentUser._id;
	  		// let compId= this.props.userdetail.companydetail.company_id;
	  		//this.props.fetchCompnyUsers(compId);
	  	}
	}
	componentWillReceiveProps(newProps) {
		if(newProps.profile.addEditDeleteTeamMember && newProps.profile.addEditDeleteTeamMember!==''){
			this.props.fetchLoginUserDetail();
			this.props.unsetAddEditMemberFlag();
			this.props.history.push(`/user-account`);
		}
	}

    filterToggle(){
		let value =  (this.state.filter === 'active-dashboard') ? 'deactivate-dashboard' : 'active-dashboard' 
	  	this.setState({ filter : value });
    }
	editMember(member) {
	    this.props.history.push(`/user-account/team/${member}`);
	}
    addTeam(){
  		this.props.history.push(`/user-account/add`);
  	}
	addMemberSave(name,type,email,id,company_id){
	  	this.props.addMemberSave(name,type,email,id, company_id);
	}
  	editMemberSave(name,type,email,id){
  		this.props.editMemberSave(name,type,email,id);
  	}
  	deleteMember(e){
  		this.props.deleteUser(e);
  	}
	renderUsers(){
	  	if( !this.props.userdetail || !this.props.userdetail.companymembers) {
	      return null;
	    }
	  	let users=this.props.userdetail.companymembers;
	  	return users.map((u, i) => {
	  		let type=u.type===1?'Admin':'Team Member';
	  		return(
	  			<tr key={`member${u._id}`} onClick={(e)=>{this.editMember(u._id)}}>
					<td data-title="Name" >{u.name}</td>
					<td data-title="Email">{u.email}</td>
					<td data-title="Type">{type}</td>
				</tr>
	  			);
	  	});
	}
    render() {
      	if( !this.props.userdetail ) {
	      return null; // TODO: Return a loading indicator
	    }
      	let users=this.renderUsers();
        return(<div>
        		<Header />
        		    <Route path={`${this.props.match.url}/add`} component={()=> <EditMember loginUser={this.props.userdetail} addMemberSave={this.addMemberSave}/>} />
        			<Route path={`${this.props.match.url}/team/:userId`} component={()=> <EditMember editMemberSave={this.editMemberSave} deleteTeam={this.deleteMember}/>} />
        			
			        <Route exact path={this.props.match.url} render={() => (
			        	<div>
        		   <div className="dashboard-page">
                    <div className={`right-content-dashboard ${this.state.filter}`}>
	                   	<div className="dashboard-content-sec table-dashboard audio-visual-content">
	                   		<div className="top-heading">
								<div className="back-button-heading">
									<h2>User Account</h2>
								</div>
								<div className="right-job-id" download>
									<RaisedButton 
                                   		label="Add User" 
                                   		type="submit"
                                   		icon={<i className="zmdi zmdi-account-add" ></i>}
                                   		labelColor="#fff" 
                                   		labelStyle={{'fontWeight': '500' }}
                                   		fullWidth={false}
                                   		onClick={this.addTeam}
                                   	/>
								</div>
							</div>
	                   		<div className="dashboard-table-data margb20px">
	                   			<div className="audio-visual-list">
	                   				<table className="dashboard-table table-bordered responsive-table">
	                   					<thead>
	                   						<tr>
	                   							<th>User Name</th>
	                   							<th>Email</th>
	                   							<th>Role</th>
	                   						</tr>
	                   					</thead>
	                   					<tbody>
	                   						{users}
	                   					</tbody>
	                   				</table>
	                   			</div>
	                   		</div>
	                   	</div>
                   	 </div>
                  </div>
                  </div>
                 )} />
               </div>
            )
    }
} 

const mapStateToProps = (state, props ) => {
	return {
      currentuser: state.login,
      profile: state.profile
    };
};

UserAccount = withRouter(connect(
  mapStateToProps,
  actions
)(UserAccount));

export default UserAccount;


// WEBPACK FOOTER //
// ./src/Components/Pages/UserAccount.js